import React from 'react';
import { Button } from '../ui/button';

export const SlotPicker = ({ availability, loading, selectedTime, onSelect }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="slots-loading">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="h-10 rounded-md bg-warmBeige animate-pulse" />
        ))}
      </div>
    );
  }

  if (!availability) {
    return <p className="text-sm text-gray-500" data-testid="slots-error">Pick a date to see open times.</p>;
  }

  if (!availability.isOpen) {
    return (
      <p className="text-sm text-gray-600 bg-warmBeige/70 rounded-md p-3" data-testid="slots-closed">
        {availability.message}
      </p>
    );
  }

  const openSlots = availability.slots.filter((s) => s.available);
  if (openSlots.length === 0) {
    return (
      <p className="text-sm text-gray-600 bg-warmBeige/70 rounded-md p-3" data-testid="slots-none">
        All times are booked for this date. Please try another day.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="slot-grid">
      {availability.slots.map((slot) => (
        <Button
          key={slot.time}
          type="button"
          disabled={!slot.available}
          data-testid={`slot-${slot.time}`}
          onClick={() => onSelect(slot.time)}
          className={`text-xs md:text-sm h-10 transition-colors ${
            selectedTime === slot.time
              ? 'bg-primaryOrange text-white hover:bg-accentOrange'
              : 'bg-white text-darkBrown border border-primaryOrange/30 hover:bg-warmBeige'
          } ${!slot.available ? 'opacity-40 line-through' : ''}`}
        >
          {slot.label}
        </Button>
      ))}
    </div>
  );
};
